import { css, LitElement } from 'lit';
import bootstrap from '../style-modules/bootstrap.css.js';

export class BaseElement extends LitElement {
  static get styles() {
    return [
      bootstrap,
      css`
        .help-label {
          padding: 5px 10px 10px;
          font-size: 0.75rem;
        }
        .error-label {
          color: #dc3545;
        }
        .spanLink {
          cursor: pointer;
          color: blue;
          text-decoration: underline;
        }
      `,
    ];
  }
}
